export const downloadBlob = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blob: Blob | ReadableStream<any> | any,
  filename: string
) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();
  return a;
};
